// Eventos
function handlerActivarFiltro() {
  document.querySelector('#idFiltrar').style.visibility = 'visible';
}

function handlerDesactivarFiltro() {
  document.querySelector('#idFiltrar').style.visibility = 'hidden';
}

export function listeneresVehicles() {
  render_tableVariacio.listeners = ['filterVarParam', 'updateFilterVar'];

  Dashboards.fireChange('filterDatesParam');
  Dashboards.fireChange('updateFilter');
  Dashboards.fireChange('updateFilterVar');

  // Listeners
  document
    .querySelector('#idVariacio')
    .addEventListener('click', handlerActivarFiltro);
  document
    .querySelector('#idAcessosCiutat')
    .addEventListener('click', handlerDesactivarFiltro);
  document
    .querySelector('#idViePrincCiutat')
    .addEventListener('click', handlerDesactivarFiltro);
}
